import { mergeVertices } from "three/examples/jsm/utils/BufferGeometryUtils.js";
import {
  TOOTH_GUM_TYPE,
  TOOTH_STAGE_NUMBER_KEY,
} from "../constant/toothConstant";
import gumDB from "../db/gumDB";
import { modelLoad } from "../util/modelLoader";
import { addPerform } from "../../tools/perform-tool";
import stageDB from "../db/stageDB";

const gumModelMapSingle = {};
const gumModelListSingle = [];

const loadGumModel = async (gumDOList) => {
  const gumModelPromiseList = gumDOList.map((gumDO) => {
    return modelLoad(gumDO.fileUrl, gumDO.filePath);
  });
  const gumModelResultList = await Promise.all(gumModelPromiseList);

  const gumModelResultListWithNormal = gumModelResultList.map((model) => {
    model.deleteAttribute("normal");
    const newModel = mergeVertices(model, 0.1);
    newModel.computeVertexNormals(true);
    return newModel;
  });

  return gumModelResultListWithNormal;
};

const loadGumModelList = async () => {
  addPerform({ name: "loadGumModel.start" });
  const gumDOList = gumDB.getGumDOList();

  const gumModelResultList = await loadGumModel(gumDOList);

  for (let i = 0; i < gumDOList.length; i++) {
    const gumDO = gumDOList[i];
    const { stageNumber, toothGumType } = gumDO;

    const gumModel = {
      stageNumber,
      toothGumType,
      model: gumModelResultList[i],
    };

    const key = `${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}.${TOOTH_GUM_TYPE}${toothGumType}`;

    gumModelMapSingle[key] = gumModel;
    gumModelListSingle.push(gumModel);
  }
  addPerform({ name: "loadGumModel.end" });
};

const loadGumModelListByStageNumber = async (stageNumber) => {

  const upperStageDO = stageDB.getStageDOFromStageNumberAndToothGumType(
    stageNumber,
    TOOTH_GUM_TYPE.UPPER
  );

  const lowerStageDO = stageDB.getStageDOFromStageNumberAndToothGumType(
    stageNumber,
    TOOTH_GUM_TYPE.LOWER
  );

  const upperGumDO = gumDB.getGumDOByStageNumberAndToothGumType(
    upperStageDO.activeStageNumber,
    TOOTH_GUM_TYPE.UPPER
  );

  const lowerGumDO = gumDB.getGumDOByStageNumberAndToothGumType(
    lowerStageDO.activeStageNumber,
    TOOTH_GUM_TYPE.LOWER
  );

  const upperGumModel = getGumModelByStageNumberAndToothGumType(
    upperStageDO.activeStageNumber,
    TOOTH_GUM_TYPE.UPPER
  );

  const lowerGumModel = getGumModelByStageNumberAndToothGumType(
    lowerStageDO.activeStageNumber,
    TOOTH_GUM_TYPE.LOWER
  );

  const gumDOList = [];

  if (upperGumDO && !upperGumModel) {
    gumDOList.push(upperGumDO);
  }

  if (lowerGumDO && !lowerGumModel) {
    gumDOList.push(lowerGumDO);
  }

  const gumModelResultList = await loadGumModel(gumDOList);


  for (let i = 0; i < gumDOList.length; i++) {
    const gumDO = gumDOList[i];
    const { stageNumber, toothGumType } = gumDO;

    const gumModel = {
      stageNumber,
      toothGumType,
      model: gumModelResultList[i],
    };

    const key = `${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}.${TOOTH_GUM_TYPE}${toothGumType}`;

    gumModelMapSingle[key] = gumModel;
    gumModelListSingle.push(gumModel);
  }
};

const getGumModelByStageNumberAndToothGumType = (stageNumber, toothGumType) => {
  return gumModelMapSingle[
    `${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}.${TOOTH_GUM_TYPE}${toothGumType}`
  ];
};

const getGumModelList = () => {
  return gumModelListSingle;
};

export default {
  loadGumModelList,
  loadGumModelListByStageNumber,
  getGumModelList,
  getGumModelByStageNumberAndToothGumType,
};
